export const START_TIMER_PRACTICE_EXAM = 'START_TIMER_PRACTICE_EXAM';
export const STOP_TIMER_PRACTICE_EXAM = 'STOP_TIMER_PRACTICE_EXAM';
export const UPDATE_TIMER_PRACTICE_EXAM = 'UPDATE_TIMER_PRACTICE_EXAM';
export const SET_INITIAL_TIME_PRACTICE_EXAM =
  'practice_exam/SET_INITIAL_TIME_PRACTICE_EXAM';

export const GET_WEEKLY_PRACTICE_EXAMS =
  'practice_exam/GET_WEEKLY_PRACTICE_EXAMS';
export const SET_CHECK_PRACTICE_EXAM_STATUS_LOADING =
  'practice_exam/SET_CHECK_PRACTICE_EXAM_STATUS_LOADING';
export const SET_CHECK_PRACTICE_EXAM_FLAG =
  'practice_Exam/SET_CHECK_PRACTICE_EXAM_FLAG';
export const SET_RESULTS_SUMMARIZED = 'practice_Exam/SET_RESULTS_SUMMARIZED';

export const START_PRACTICE_EXAM = 'practice_exam/START_PRACTICE_EXAM';
export const SET_PRACTICE_EXAM_AVAILABLE =
  'practice_exam/SET_PRACTICE_EXAM_AVAILABLE';
export const SET_EXAM_QUESTIONS = 'practice_exam/SET_EXAM_QUESTIONS';
export const SET_PRACTICE_EXAM = 'practice_exam/SET_PRACTICE_EXAM';
export const SET_NEW_DETAIL = 'practice_exam/SET_NEW_DETAIL';
export const UPDATE_PRACTICE_EXAM_RESULTS =
  'practice_exam/UPDATE_PRACTICE_EXAM_RESULTS';
export const SUBMIT_PRACTICE_EXAM = 'practice_exam/SUBMIT_PRACTICE_EXAM';
export const PRACTICE_EXAM_RESULTS = 'practice_exam/PRACTICE_EXAM_RESULTS';
export const SET_SUBMIT_PRACTICE_EXAM_SUCCESS =
  'practice_exam/SET_SUBMIT_PRACTICE_EXAM_SUCCESS';
export const SET_SUBMIT_PRACTICE_EXAM_LOADING =
  'practice_exam/SET_SUBMIT_PRACTICE_EXAM_LOADING';

export const SET_REVIEW_MODE = 'practice_exam/SET_REVIEW_MODE';

export const IS_LOADING_PRACTICE_EXAM_QUESTIONS =
  'IS_LOADING_PRACTICE_EXAM_QUESTIONS';

export const SET_RETAKE_MODE = 'practice_exam/SET_RETAKE_MODE';
export const GET_PRACTICE_EXAM_QUESTIONS =
  'practice_exam/GET_PRACTICE_EXAM_QUESTIONS';
export const GENERATE_CUSTOM_PRACTICE_EXAM =
  'practice_exam/GENERATE_CUSTOM_PRACTICE_EXAM';
export const SET_CUSTOM_PRACTICE_EXAM =
  'practice_exam/SET_CUSTOM_PRACTICE_EXAM';
export const SET_CUSTOM_PRACTICE_EXAM_STATUS =
  'practice_exam/SET_CUSTOM_PRACTICE_EXAM_STATUS';
export const SET_CUSTOM_PRACTICE_EXAM_LOADING =
  'practice_exam/SET_CUSTOM_PRACTICE_EXAM_LOADING';
export const GET_CUSTOM_PRACTICE_EXAM_REFERENCES =
  'practice_exam/GET_CUSTOM_PRACTICE_EXAM_REFERENCES';
export const SET_CUSTOM_PRACTICE_EXAM_REFERENCES =
  'practice_exam/SET_CUSTOM_PRACTICE_EXAM_REFERENCES';
export const SET_CUSTOM_PRACTICE_EXAM_REFERENCES_LOADING =
  'practice_exam/SET_CUSTOM_PRACTICE_EXAM_REFERENCES_LOADING';
export const GET_CUSTOM_PRACTICE_EXAM_SETTINGS =
  'practice_exam/GET_CUSTOM_PRACTICE_EXAM_SETTINGS';
export const SET_CUSTOM_PRACTICE_EXAM_SETTINGS =
  'practice_exam/SET_CUSTOM_PRACTICE_EXAM_SETTINGS';
export const SET_CUSTOM_PRACTICE_EXAM_SETTINGS_LOADING =
  'practice_exam/SET_CUSTOM_PRACTICE_EXAM_SETTINGS_LOADING';
